import { Deserializable } from '../protocols/deserializable';

export class RemittanceStatus implements Deserializable {
  public id!: number;
  public name!: string;

  public onDeserialize(): void {}
}
